import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	SignatureSharedCreateSignature,
	type SignatureSharedCreateSignatureMutation,
	type SignatureSharedCreateSignatureMutationVariables,
} from './create.graphql';
import { normalizeSignPetitionErrorResponse } from './normalizeSignPetitionErrorResponse';
import { normalizeSignPetitionResponse } from './normalizeSignPetitionResponse';
import type { SignPetitionInput, SignPetitionResult, SignPetitionShareBandit } from './types';

type Options = {
	signature: SignPetitionInput;
	shareBandit?: SignPetitionShareBandit;
};

export async function createSignature(
	{ signature, shareBandit }: Options,
	{ gql: { fetch } }: UtilityContext,
): Promise<SignPetitionResult> {
	let data: SignatureSharedCreateSignatureMutation | null | undefined;
	try {
		const result = await fetch<SignatureSharedCreateSignatureMutation, SignatureSharedCreateSignatureMutationVariables>(
			{
				query: SignatureSharedCreateSignature,
				variables: {
					shouldRewardShareBandit: !!shareBandit,
					rewardShareBanditInput: {
						banditId: shareBandit?.id || '',
						variantName: shareBandit?.variant || '',
					},
					signatureInput: signature,
				},
				path: `/signPetition/${signature.petitionId}`,
				rejectOnError: true,
				batched: false, // to ensure this rate limited mutation is not batched
			},
		);
		({ data } = result);
	} catch (err) {
		return normalizeSignPetitionErrorResponse(err);
	}

	if (!data.signPetition) throw new Error('Unexpected sign petition response');
	return normalizeSignPetitionResponse(data.signPetition);
}
